exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Tip__Tip__1fLG9m {\n  position: relative;\n  display: table;\n}\n.Tip__text__19m_XZ {\n  position: fixed;\n  z-index: 2;\n  -webkit-transform: translate(-50%, -30px);\n          transform: translate(-50%, -30px);\n  display: block;\n  padding: 2px 4px;\n  color: #4a4a4a;\n  background: #fff;\n  border-radius: 3px;\n  pointer-events: none;\n  opacity: 0;\n}\n.Tip__text__19m_XZ:after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  border: 8px solid transparent;\n  border-top-color: #fff;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n.Tip__text__19m_XZ.Tip__isOpen__cuf-73 {\n  opacity: 1;\n  pointer-events: all;\n}\n", ""]);

// exports
exports.locals = {
	"Tip": "Tip__Tip__1fLG9m",
	"text": "Tip__text__19m_XZ",
	"isOpen": "Tip__isOpen__cuf-73"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/src??ref--2-2!./node_modules/stylus-loader!./web_modules/trustar/components/Tip.styl
// module id = 3644
// module chunks = 39